import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';

import { RawFolder } from '@/core/types';
import { entityKeyFactory } from '@/core/query-keys';
import { handleResponse } from '@/core/utils';
import { EntityGateway } from '@/core/gateways';
import { useCurrentUser } from '@/core/hooks/use-current-user';

interface QueryProps {
  pageParam?: number;
}

export interface PagedSharedPage {
  folders: RawFolder[];
  nextPage: number | null;
  previousPage: number | null;
}

async function fetchShared({ pageParam }: QueryProps): Promise<PagedSharedPage> {
  const { folders, nextPage, previousPage } = await handleResponse(
    EntityGateway.shared({ pageParam })
  );

  return { folders, nextPage, previousPage };
}

export function useFetchShared(options?: UseInfiniteQueryOptions<PagedSharedPage, Error>) {
  const { data: user } = useCurrentUser();

  return useInfiniteQuery<PagedSharedPage, Error>(
    entityKeyFactory.shared,
    ({ pageParam = 1 }) => fetchShared({ pageParam }),
    {
      getNextPageParam: (lastPage) => lastPage.nextPage,
      enabled: !!user,
      ...options
    }
  );
}
